import { sitemapData } from './staticData';
import { useFetchAllRoutes } from '../../data/swrs/sitemap';

const SitemapGenerator = () => {
	const { data: sitemapRoutes } = useFetchAllRoutes();

	const generateSitemapXml = () => {
		const baseUrl = `${import.meta.env.VITE_APP_FRONTEND_URL}`;

		const xmlHeader = `<?xml version="1.0" encoding="UTF-8"?>\n<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n`;
		const xmlFooter = `</urlset>`;

		const urlEntries = sitemapRoutes?.routes
			.map(
				route => `
      <url>
        <loc>${baseUrl}${route}</loc>
        <changefreq>weekly</changefreq>
        <priority>0.8</priority>
      </url>
    `
			)
			.join('\n');

		return xmlHeader + urlEntries + xmlFooter;
	};

	return (
		<div>
			<pre>{sitemapRoutes?.routes?.length > 0 ? generateSitemapXml() : sitemapData}</pre>
		</div>
	);
};

export default SitemapGenerator;
